import React, { ReactNode } from "react";

import { Box, IconButton, makeStyles, colors } from "@material-ui/core";
import { Close } from "@material-ui/icons";

interface ModalProps {
  children: ReactNode;

  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      width: "100%",
      overflowX: "hidden",
      overflowY: "auto",

      backgroundColor: theme.palette.common.white,
      zIndex: theme.zIndex.modal,
    },

    wrapper: {
      position: "relative",

      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },

    close: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(2),
      color: colors.grey[800],
    },
  }),
  { name: "modal-styles" }
);

export default function Modal(props: ModalProps) {
  const classes = useStyles(props);
  // Props
  const { children, open, onClose } = props;

  return open ? (
    <Box className={classes.root}>
      <Box className={classes.wrapper}>
        <Box component="span" className={classes.close}>
          <IconButton
            className="close"
            onClick={(_) => onClose()}
            aria-expanded={true}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </Box>
        <Box className={classes.wrapper}>{children}</Box>
      </Box>
    </Box>
  ) : (
    <></>
  );
}

Modal.defaultProps = {
  open: false,
};
